import { makeStyles } from "@material-ui/core/styles";
import { Colors } from "../../../theme/colors";

const useStyles = makeStyles(() => ({
  flexWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  },
  title: {
    fontWeight: "bold",
    fontSize: "16pt",
    color: Colors.Grey,
  },
  description: {
    margin: "20px 0",
    width: "80%",
    fontSize: "14pt",
    color: Colors.Grey,
  },
  cancelBtn: {
    position: "absolute",
    bottom: "0",
    right: "50px",
    backgroundColor: Colors.Grey,
    marginLeft: "10px",
    "&:hover": {
      opacity: 0.75,
    },
  },
}));

export default useStyles;
